// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography } from '@mui/material';
// hooks
import useResponsive from './useResponsive';
// sections
import LoginForm from './LoginForm';
import logo from './RezGlobal.png'
import wp6 from './wp6.jpg'
import wp4 from './wp4.jpg'
import wp1 from './wp1.jpg'
import wp2 from './wp2.jpg'

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 410,
  margin: 'auto',
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const logoStyle = {

  minHeight: '10vh',
  maxWidth: '20vh',
  padding: '10px',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
}
const logoName = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '40px'
}


// ----------------------------------------------------------------------

export default function Login({ setLoginSuccess }) {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  const wp = [wp6, wp4, wp2, wp1]
  const d = new Date();
  let day = d.getDay();//0-6 // Sunday-Saturday


  return (
    <RootStyle sx={{
      backgroundImage: `url(${wp[day % 3]})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      minHeight: '100vh',
      height: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <Container maxWidth="sm">

        <ContentStyle>
          <img src={logo} style={{
            height: '25vh', width: '45vh', padding: '5px', margin: 'auto',
            display: 'flex', justifyContent: 'center', flexDirection: 'column', marginBottom: '15px'
          }} />
          {/* <Typography variant="h4" gutterBottom style={logoName}>
              <strong>CALEDONREZ</strong>
            </Typography> */}

          {/* <Typography sx={{ color: 'text.secondary', mb: 3 }}>Enter your credentials below : </Typography> */}

          <LoginForm setLoginSuccess={setLoginSuccess} />

        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
